"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var _General_1 = __importDefault(require("./_General"));
var _Bot_1 = __importDefault(require("./_Bot"));
var _Feedback_1 = __importDefault(require("./_Feedback"));
var FileUpload_1 = __importDefault(require("./FileUpload"));
exports["default"] = {
    blocks: [_General_1["default"], _Bot_1["default"], _Feedback_1["default"], FileUpload_1["default"]],
};
